import React, {createContext, useContext, useEffect, useMemo, useState} from "react";

import WebGalleryStore from "../stores/WebGalleryStore";
import MediaValetApi from "../api/MediaValet";

export const WebGalleryStoreContext = createContext({} as WebGalleryStore);

export const WebGalleryStoreProvider: React.FunctionComponent<{
  config: MediaValetConfiguration;
}> = ({ children, config }) => {
  const store = useMemo(() => {
    return new WebGalleryStore({
      api: new MediaValetApi({
        endpoint: config.api || process.env.REACT_APP_MEDIA_VALET_API_ENDPOINT,
      }),
      features: config.currentOrgUnit?.features,
      logoSrc: config.logos?.medium,
    })
  }, []);

  return (
    <WebGalleryStoreContext.Provider value={store}>
      {children}
    </WebGalleryStoreContext.Provider>
  );
};

export const WebGalleryStoreConsumer = WebGalleryStoreContext.Consumer;

export const useWebGalleryStore = (): WebGalleryStore =>
  useContext(WebGalleryStoreContext);
